// extracted by mini-css-extract-plugin
module.exports = {"page-wrapper":"PageWrapper_page-wrapper__29vA8","page-content":"PageWrapper_page-content__3HSZS"};